import React from "react";
import EmailLayout from '../EmailLayout';
import EmailLayoutWidget from './EmailLayoutWidget';
import i18n from '../../locales/i18n';

import imagePlaceholder from '../../assets/images/imagePlaceholder.webp';
import { email_widget_wrapper_style, email_widget_image_style } from './emailWidgetPreviewStyle';

/** Class representing a PDF layout image widget. */
class ImageWidget extends EmailLayoutWidget {

    constructor(properties) {
        super({
            ...(ImageWidget.getDefaultOptions()),
            ...properties,
            type: EmailLayout.IMAGE,
            subType: EmailLayout.CUSTOM
        });
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            options: {
                style: {
                    align: 'center',
                    objectFit: "contain",
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }
                },
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            EmailLayout.OPTION_IMAGE,
            EmailLayout.OPTION_OBJECT_FIT,
            EmailLayout.OPTION_ALIGNMENT,
            EmailLayout.OPTION_PADDING,
        ]);
    }

    /**
     * Return this widget preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {EmailLayout} layout
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreview(props) {
        const style = this.options?.style || {};
        const imageStyle = {
            width: '100%',
            height: 'auto',
            ...email_widget_image_style(style),
        };

        return (
            <div style={{
                ...email_widget_wrapper_style(style),
                height: 'auto',
            }}>
                <>
                    { this.options?.rfc2397_data && (
                        <img ref={props.ref} src={ this.options.rfc2397_data } style={ imageStyle } alt={i18n.t('layouts.alt_custom_upload')} />
                    )}

                    { !this.options?.rfc2397_data && (
                        <div>
                            <img src={ imagePlaceholder } style={imageStyle} alt={i18n.t('layouts.alt_click_to_upload')} />
                        </div>
                    )}
                </>
            </div>
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'picture-o';
    }
}

export default ImageWidget;
